module.exports = __webpack_public_path__ + "img/Path 16 Copy@3x.224c68d4.png";